export enum AverageMethod {
  MEAN = 'MEAN',
  WEIGHTED = 'WEIGHTED',
  MEDIAN = 'MEDIAN',
}
